export default "__VITE_PUBLIC_ASSET__5b7c3c80__"